import React, { useEffect, useState } from "react";
import permissionService from "../Services/permissionService";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../Modals/Loading";

const AddPermission = ({ edit = false }) => {
  const [loading, setLoading] = useState(false);
  const [ID, setID] = useState();
  const [data, setData] = useState({
    name: "",
  });
  const [errors, setErrors] = useState({
    name: false,
  });
  const [regex, setRegex] = useState({
    name: /.{1,50}$/,
  });

  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  useEffect(() => {
    if (edit) {
      if (params.get("id")) {
        setLoading(true);
        permissionService.fetchSingle(params.get("id")).then((res) => {
          setData((d) => ({ ...d, name: res.permission.name }));
          setID(res.permission.id);
          setLoading(false);
        });
      }
    }
  }, []);

  const handleChange = (e) => {
    setData((prevData) => ({ ...prevData, [e.target.name]: e.target.value }));
    setErrors((prevErrors) => ({ ...prevErrors, [e.target.name]: false }));
  };

  useEffect(() => {}, []);

  const submit = () => {
    setLoading(true);
    let hasError = false;
    Object.keys(data).forEach((field) => {
      if (!regex[field]?.test(data[field])) {
        setErrors((prevErrors) => ({ ...prevErrors, [field]: true }));
        hasError = true;
      }
    });

    if (hasError) {
      toast.error("Please fill all the required fields");
      setLoading(false);
    } else {
      if (!edit) {
        permissionService
          .create(data)
          .then(() => {
            setLoading(true);
            toast.success("Permission added successfully!");
            navigate("/permission");
            setLoading();
          })
          .catch(() => {
            toast.error("Error adding permission.");
            setLoading(false);
          });
      } else {
        permissionService
          .update(ID, data)
          .then(() => {
            toast.success("Permission Updated successfully!");
            navigate("/permission");
          })
          .catch(() => {
            toast.error("Error updating permission.");
            setLoading(false);
          });
      }
    }
  };

  return (
    <>
      {loading ? (
        <div>
          <Loading />
        </div>
      ) : (
        <main className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
          <p className="font-bold text-3xl text-secondary">Add Permission</p>
          <div className="mt-10">
            <div className="grid grid-cols-1 gap-2 md:grid-cols-2 md:gap-16">
              <div>
                <label className="primary-label">Name</label>
                <input
                  name="name"
                  value={data.name}
                  onChange={(e) => handleChange(e)}
                  placeholder="Name"
                  className={`primary-input ${
                    errors.name ? "border-red-500" : ""
                  }`}
                />
                {errors.name && (
                  <div className="text-red-500 text-sm mt-1">
                    Name is required and must be less than 50 characters.
                  </div>
                )}
              </div>
            </div>
            <div className="flex items-center justify-center mt-12">
              <button
                onClick={() => submit()}
                disabled={loading}
                className={`button-primary ${loading ? "bg-gray-400" : ""}`}
              >
                {loading ? "Adding..." : "ADD"}
              </button>
            </div>
          </div>
        </main>
      )}
    </>
  );
};

export default AddPermission;
